import injectReducer from 'store/injectReducer';
import {
	failureActionHandler,
	requestActionHandler,
	successActionHandler,
} from 'store';
import { RoleTypes } from 'models';
import { IAuthData, IAuthReducer, IAuthUserName } from './models';
import * as types from './ActionTypes';

export const InitialAuthReducer: IAuthReducer = {
	partnerId: '',
	login: '',
	firstName: '',
	lastName: '',
	email: '',
	isActive: false,
	role: RoleTypes.NONE,
	profilePictureUrl: '',
	isLoading: false,
};

export default injectReducer(InitialAuthReducer, {
	[types.GET_USER_DATA.REQUEST]: requestActionHandler,

	[types.GET_USER_DATA.FAILURE]: failureActionHandler,

	[types.SET_AUTH_ERROR]: failureActionHandler,

	[types.GET_USER_DATA.SUCCESS]: (
		state: IAuthReducer,
		{ payload }: { payload: IAuthData },
	): IAuthReducer => ({
		...successActionHandler(state),
		...payload,
	}),

	[types.UPDATE_USER_NAME]: (
		state: IAuthReducer,
		{ payload }: { payload: IAuthUserName },
	): IAuthReducer => ({
		...successActionHandler(state),
		...payload,
	}),
});
